'use strict';

var util = require('../../util/property-util');
var arrayUtil = require('../../util/array-util');
var graphUtil = require('../../util/graph-util');
var Highcharts = require('highcharts/highstock');

module.exports = /*@ngInject*/ ["ContentStatisticsResourceService", "ChartFactory", "HighChartFactory", function (ContentStatisticsResourceService, ChartFactory, HighChartFactory) {
    var factory = {};

    factory.nameValueToPieChartObjectTransformer = function (data) {
        return data.map(function (entry) {
            return {name: entry.name, y: entry.value}
        });
    };

    factory.getData = function (requestName, projectId, from, to) {
        return ContentStatisticsResourceService.report()[requestName]({
            projectId: projectId,
            from: from,
            to: to
        }).$promise;
    };

    /**
     * This function takes data and creates a drilldown group structure (for highcharts)
     * @param Array data    data array (with name-value pairs)
     * @returns {*[{name,y},{name,y}]}
     */
    factory.createDrillDownGroups = function (data) {

        // group data
        // since we only have to group versions, we can split the string on the first occurring number
        // eg: Android 5.11 > Android, Android 4.4.2 > Android, iOS 8.1.2 > iOS
        // we do this action for every dataentry, and push the entry in the corresponding group's data array
        // example of the resulting map:
        // - Android : { y:150,
        //               drilldown: { name: "Android",
        //                            data: [
        //                                    {name: "Android 5.11", y:100},
        //                                    {name: "Android 4.4.2", y: 50} ],
        //                            color: "#23a289" },
        //               color: "#23a289"
        //              }
        // - iOS :     { y:50,
        //               drilldown: { name: "iOS",
        //                            data: [
        //                                    {name: "iOS 8.4", y:10},
        //                                    {name: "iOS 7.1.2", y: 40} ],
        //                            color: "#ab72b1" },
        //               color: "#ab72b1"
        //              }
        var map = new Map();
        var index = 0;
        data.forEach(function (entry) {
            var prefix = entry.name.split(/[0-9]/)[0].trim();
            var found = map.get(prefix);
            if (util.isDefined(found)) {
                found.drilldown.data.push({name: entry.name, y: entry.value});
            } else {
                var obj = {
                    y: 0,
                    drilldown: {
                        name: prefix,
                        data: [{name: entry.name, y: entry.value}],
                        color: graphUtil.getSemiRandomColorArray()[index]
                    },
                    color: graphUtil.getSemiRandomColorArray()[index]
                };
                index++;
                map.set(prefix, obj);
            }
        });

        // calculate the y value for the group (total of all individual elements)
        map.forEach(function (value) {
            var sum = 0;
            value.drilldown.data.forEach(function (entry) {
                sum = sum + entry.y;
            });
            value.y = sum;
        });


        var groupedData = [], versionsData = [];

        // Build the data arrays
        map.forEach(function (value, key) {
            groupedData.push({
                name: key,
                y: value.y,
                color: value.color
            });
            var index = 0;
            value.drilldown.data.forEach(function (item) {
                var brightness = 0.2 - (index / value.drilldown.data.length) / 5;
                versionsData.push({
                    name: item.name,
                    y: item.y,
                    color: Highcharts.Color(value.color).brighten(brightness).get()
                });
                index++;
            });
        });
        return [groupedData, versionsData];
    };

    factory.getPieSerie = function (data, serieName, tooltip) {
        var serie = HighChartFactory.createPieSeries(serieName, data);
        if (util.isDefined(tooltip)) {
            serie.tooltip = tooltip;
        }
        return serie;

    };

    factory.getPieDonutSeries = function (inner, outer, innerName, outerName) {
        var innerSerie = {
            name: innerName,
            data: inner,
            size: '60%',
            dataLabels: {
                formatter: function () {
                    return this.y > 5 ? this.point.name : null;
                },
                distance: -30
            }
        };
        var outerSerie = {
            name: outerName,
            data: outer,
            size: '80%',
            innerSize: '60%',
            dataLabels: {
                formatter: function () {
                    // display only if larger than 1
                    return this.y > 1 ? '<b>' + this.point.name + ':</b> (' + Math.round(100 * this.percentage) / 100 + '%)' : null;
                }
            }
        };
        return [innerSerie, outerSerie];
    };

    factory.getColumnSerie = function (data, serieName, percentages, tooltip) {
        var total = 1;
        if (percentages) {
            total = arrayUtil.dataToPercentages(data, "value", "percentage", 100, 3);
        }

        var array = [];
        data.forEach(function (entry) {
            array.push([entry.name, entry.value])
        });
        var serie = {
            name: serieName,
            data: array,
            dataLabels: {
                enabled: true
            }
        };
        if (percentages) {
            serie.dataLabels.formatter = function () {
                var pcnt = (this.y / total) * 100;
                return this.y + " (" + Highcharts.numberFormat(pcnt) + '%)';
            }
        } else {
            serie.dataLabels.format = '{point.y} %'
        }
        if (util.isDefined(tooltip)) {
            serie.tooltip = tooltip;
        }
        return serie;
    };

    factory.getSynopsis = function (projectId, from, to, callback) {
        ContentStatisticsResourceService.report().getSynopsis({projectId: projectId, from: from, to: to},
            function (data) {
                callback(data);
            });
    };
    return factory;
}];